<template>
  <div>
    <div class="container sm:px-10">
      <div class="block xl:grid grid-cols-2 gap-4">
        <!-- BEGIN: Login Info -->
        <div class="hidden xl:flex flex-col min-h-screen">
          <a href="" class="-intro-x flex items-center pt-5">
            <img
              alt="Image Logo"
              class="w-6"
              :src="require(`@/assets/images/simplelogo.png`).default"
            />
            <span class="text-white text-lg ml-3">
              <span class="font-medium">Asistomedia</span>
            </span>
          </a>
          <div class="my-auto">
            <div class="-intro-x text-white font-medium text-4xl leading-tight">
              A pocos clicks de<br />
              iniciar sesión
            </div>
            <div
              class="
                -intro-x
                mt-5
                text-lg text-white text-opacity-70
                dark:text-gray-500
              "
            >
              Hola! Aqui esta toda la información de su residente, en un solo lugar
            </div>
          </div>
        </div>
        <!-- END: Login Info -->
        <!-- BEGIN: Login Form -->
        <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
          <div
            class="
              my-auto
              mx-auto
              xl:ml-20
              bg-white
              dark:bg-dark-1
              xl:bg-transparent
              px-5
              sm:px-8
              py-8
              xl:p-0
              rounded-md
              shadow-md
              xl:shadow-none
              w-full
              sm:w-3/4
              lg:w-2/4
              xl:w-auto
            "
          >
            <form @submit.prevent="signInSession">
              <div class="w-full flex justify-center">
                <img
                  alt="Icewall Tailwind HTML Admin Template"
                  class="w-1/2"
                  :src="require(`@/assets/images/logo.png`).default"
                />
              </div>
              <div class="intro-x mt-8 w-5/6">
                <input
                  v-model="email"
                  type="email"
                  class="
                    intro-x
                    login__input
                    form-control
                    py-3
                    px-4
                    border-gray-300
                    block
                  "
                  placeholder="Correo"
                  required
                />
                <input
                  v-model="password"
                  required
                  type="password"
                  class="
                    intro-x
                    login__input
                    form-control
                    py-3
                    px-4
                    border-gray-300
                    block
                    mt-4
                  "
                  placeholder="Contraseña"
                />
              </div>
              <div
                v-if="false"
                class="
                  intro-x
                  flex
                  text-gray-700
                  dark:text-gray-600
                  text-xs
                  sm:text-sm
                  mt-4
                "
              >
                <div class="flex items-center mr-auto">
                  <input
                    id="remember-me"
                    type="checkbox"
                    class="form-check-input border mr-2"
                  />
                  <label class="cursor-pointer select-none" for="remember-me"
                    >Remember me</label
                  >
                </div>
                <a href="">Forgot Password?</a>
              </div>
              <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
                <button
                  class="
                    btn btn-primary
                    py-3
                    px-4
                    w-full
                    xl:w-32 xl:mr-3
                    align-top
                  "
                >
                  Entrar
                </button>
              </div>
              <div
                v-if="false"
                class="
                  intro-x
                  mt-10
                  xl:mt-24
                  text-gray-700
                  dark:text-gray-600
                  text-center
                  xl:text-left
                "
              >
                By signin up, you agree to our <br />
                <a class="text-theme-17 dark:text-gray-300" href=""
                  >Terms and Conditions</a
                >
                &
                <a class="text-theme-17 dark:text-gray-300" href=""
                  >Privacy Policy</a
                >
              </div>
            </form>
          </div>
        </div>
        <!-- END: Login Form -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: ''
    }
  },
  beforeMount() {
    cash('body')
      .removeClass('main')
      .removeClass('error-page')
      .addClass('login')
  },
  methods: {
    async signInSession() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.post('/login', {
          username: this.email,
          password: this.password
        })
        const responseUser = await this.axios.get('/user-auth-info', {
          headers: {
            Authorization: `Bearer ${response.data.access_token}`
          }
        })
        this.$store.commit('auth/setSessionData', {
          token: response.data.access_token,
          user: responseUser.data
        })
        this.$router.push('/')
      } catch (error) {
        this.$toast.error('Credenciales incorrectas', {
          position: 'top-right'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    }
  }
}
</script>
